// check if they want low motion, if so we will not auto play videos, and disable the progress bar animation. 
window.preferslowmotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
// console.log( "prefers reduced motion?", window.preferslowmotion );